<template>  
  <FormulateInput
    type="radio"
    :name="name"
    :label="label"
    :options="options"
    :validation="validation"
    @blur-context="inputCallback"
    v-bind="$attrs"
    @validation="$emit('validation', $event)"
    v-model="value"
  />
</template>
<script>
export default {
  name: "RadioInputComponent",
  props: {
    name:{
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      // type: Array,
      required: true,
    },
    validation: {
      // type: String,
      required: true,
    },
    value: {
      type: Object,
      required: false
    }
  },

  methods: {
    inputCallback(value){
      this.$emit('update', {
        name: this.name,
        model: value
      })
    }
  }
};
</script>